import React from "react"

import {
  ProjectHistoryOverlay,
  ProjectHistoryOverlayPayload
} from "./ProjectHistoryOverlay"
import { useProjectHistoryOverlayModel } from "./model/useProjectHistoryOverlayModel"

export interface ProjectHistoryOverlayConnectorProps {
  payload: ProjectHistoryOverlayPayload
}

export const ProjectHistoryOverlayConnector = React.memo(
  (props: ProjectHistoryOverlayConnectorProps) => (
    <ProjectHistoryOverlay {...useProjectHistoryOverlayModel(props)} />
  )
)
